import React from 'react';
import "../style/main.css";
import main from "../Assets/Home.jpg";
import { TypeAnimation } from 'react-type-animation';
import { motion } from "motion/react";

const scrollToProducts = () => {
    document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
};

const Main = () => {
    return (
        <div className="wrapper" id="home">
            <div className="heroMedia">
                <motion.img
                    className="mainImg"
                    src={main}
                    loading="lazy"
                    decoding="async"
                    alt="Modern kitchen fitted with a Bonzer chimney and induction hob"
                    initial={{ scale: 1.08 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 8, ease: "easeOut" }}
                />
                <div className="heroScrim" />
                <span className="heroGlow" aria-hidden="true" />
            </div>

            <div className="introBox">
                <motion.span
                    className="heroEyebrow"
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.15 }}
                >
                    Kitchen hardware, refined
                </motion.span>

                <motion.h1
                    className="heroHeadline"
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.3 }}
                >
                    Elevate your <span className="heroAccent">cooking</span> experience
                </motion.h1>

                <motion.div
                    className="intro"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.5 }}
                >
                    <TypeAnimation
                        sequence={[
                            'Stylish, efficient kitchen chimneys.',
                            2200,
                            'Induction cooktops built to perform.',
                            2200,
                            'Engineered for kitchens that don\'t stop.',
                            2200,
                        ]}
                        wrapper="span"
                        speed={50}
                        repeat={Infinity}
                        cursor
                    />
                </motion.div>

                <motion.div
                    className="heroActions"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.7 }}
                >
                    <a href="#products" className="heroBtn heroBtnPrimary">Explore products</a>
                    <a href="#contactUs" className="heroBtn heroBtnGhost">Get in touch</a>
                </motion.div>

                <motion.ul
                    className="heroStrip"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.7, delay: 0.9 }}
                >
                    <li>Quiet operation</li>
                    <li>Easy install</li>
                    <li>Built to last</li>
                </motion.ul>
            </div>

            <motion.button
                type="button"
                className="scrollCue"
                onClick={scrollToProducts}
                aria-label="Scroll to products"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 1.2 }}
            >
                <span className="scrollCueLine" />
                <span className="scrollCueLabel">Scroll</span>
            </motion.button>
        </div>
    );
};

export default Main;